<template>
    <app-layout title="Project Management">
        <template #header>
            <div class="flex justify-between">
                <h2 class="font-semibold text-2xl text-gray-800 dark:text-gray-200 leading-tight">
                    Quote Templates
                </h2>
                <inertia-link :href="route('admin.quote-template.create')"
                              class="max-w-min whitespace-nowrap flex items-center justify-between w-full px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-red-600 border border-transparent rounded-lg active:bg-red-600 hover:bg-red-700 focus:outline-none focus:shadow-outline-red">
                    Create quote template
                    <span class="ml-2" aria-hidden="true">+</span>
                </inertia-link>
            </div>
        </template>
        <div class="w-full overflow-hidden rounded-lg shadow">
            <template v-if="paginatedQuoteTemplates.data.length">
                <table-layout>
                    <template v-slot:theadRow>
                        <th class="px-4 py-3">Name</th>
                        <th class="px-4 py-3">Theme</th>
                        <th class="px-4 py-3">Status</th>
                        <th class="px-4 py-3 text-right">Actions</th>
                    </template>

                    <template v-slot:tbody>
                        <tr v-for="quoteTemplate in paginatedQuoteTemplates.data" class="text-gray-700 dark:text-gray-400">
                            <td class="px-4 py-3">
                                <div class="flex items-center text-sm">
                                    <div class="flex items-center">
                                        <p class="ml-2 ont-semibold">{{ quoteTemplate.name }}</p>
<!--                                        <p class="text-xs text-gray-600 dark:text-gray-400">-->
<!--                                            10x Developer-->
<!--                                        </p>-->
                                    </div>
                                </div>
                            </td>
                            <td class="px-4 py-3">
                                <div class="flex items-center text-sm">
                                    {{ quoteTemplate.theme?.name }}
                                </div>
                            </td>
                            <td class="px-4 py-3 text-xs">
                                <div class="flex items-center">
                                <span v-if="quoteTemplate.status === 0"
                                      class="px-2 py-1 font-semibold leading-tight rounded-full text-green-700 bg-green-100 dark:bg-green-700 dark:text-green-100">
                                    Active
                                </span>
                                </div>
                            </td>
                            <td class="px-4 py-3 text-right">
                                <div class="flex items-center justify-end space-x-1 text-sm">
                                    <inertia-link :href="route('admin.quote-template.edit', {quote_template: quoteTemplate.id})"
                                                  class="flex items-center justify-between px-2 py-2 text-sm font-medium leading-5 text-gray-600 rounded-lg dark:text-gray-400 focus:outline-none focus:shadow-outline-gray"
                                                  aria-label="Edit"
                                    >
                                        <svg class="w-5 h-5" aria-hidden="true" fill="currentColor"
                                             viewBox="0 0 20 20">
                                            <path
                                                d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"></path>
                                        </svg>
                                    </inertia-link>
                                    <button @click.prevent="deleteQuote(quoteTemplate)"
                                            class="flex items-center justify-between px-2 py-2 text-sm font-medium leading-5 text-gray-600 rounded-lg dark:text-gray-400 focus:outline-none focus:shadow-outline-gray"
                                            aria-label="Delete"
                                    >
                                        <svg class="w-5 h-5" aria-hidden="true" fill="currentColor"
                                             viewBox="0 0 20 20">
                                            <path fill-rule="evenodd"
                                                  d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                                  clip-rule="evenodd"></path>
                                        </svg>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </table-layout>
                <table-pagination :pagination-object="paginatedQuoteTemplates"/>
            </template>
            <template v-else>
                <h4 class="font-semibold text-gray-800 dark:text-gray-200 leading-tight">
                    No quote templates defined.
                </h4>
            </template>
        </div>
    </app-layout>
</template>

<script>
import {defineComponent, inject} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import TablePagination from "@/Jetstream/TablePagination";
import TableLayout from "@/Jetstream/TableLayout";
import JetSelect from "@/Jetstream/Select";
import Pill from "@/Jetstream/Pill";
import {Inertia} from '@inertiajs/inertia';
import {VueDraggableNext} from 'vue-draggable-next';

export default defineComponent({
    components: {
        Pill,
        TableLayout,
        TablePagination,
        AppLayout,
        JetSelect,
        draggable: VueDraggableNext,
    },
    props: {
        paginatedQuoteTemplates: {
            type: Object,
            required: true,
        },
    },
    setup() {
        const $swal = inject('$swal');
        const deleteQuote = (quoteTemplate) => {
            $swal({
                title: 'Are you sure you want to delete this quote template?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    Inertia.delete(route('admin.quote-template.destroy', {quote_template: quoteTemplate.id}));
                }
            });
        }

    return {
        deleteQuote,
    };
}
})
</script>
